const appointmentAccordion = document.querySelector('.js-appointment-accordion')

if (appointmentAccordion) {
    // Check if desktop on initial load
    if (window.innerWidth >= 768) {
        appointmentAccordion.classList.add('open');
    }

    // Handle click events
    appointmentAccordion.addEventListener('click', () => {
        appointmentAccordion.classList.toggle('open');
    })
}